// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1YmG5","overflowing":"ReadFullNote_overflowing__EYRVC"};